// storybook-check-ignore
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@opendoor/bricks/core';

import cosmosI18n from '../../../../i18n/config';

interface LoginSectionProps {
  showLogin: boolean;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin }) => {
  const { t } = useTranslation('homepage', { i18n: cosmosI18n });

  if (!showLogin) return null;

  return (
    <Link
      href={'#'}
      fontWeight="medium"
      analyticsName="cosmos-sign-in"
      aria-label=""
      color="warmgrey950"
      _hover={{
        color: 'brandBlue600',
      }}
      _focus={{
        color: 'brandBlue600',
        outline: 0,
      }}
    >
      {t('titles.signIn', 'Sign In')}
    </Link>
  );
};
